import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '../i18n'

Vue.use(Vuetify)
var option = {
  rtl: false,
}

if (process.env.VUE_APP_I18N_DIRECTION == 'rtl') {
  option.rtl = true
}else{
  option.rtl = false
}
export default new Vuetify(option)
